const API_URL = "http://localhost:3000/auth"; // URL do backend

// Função para login
export const authSignIn = async (email: string, password: string) => {
  const response = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
	body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    throw new Error("Falha na autenticação");
  }

  return await response.json(); // Retorna o token JWT
};

// Função para registro
export const authSignUp = async (email: string, password: string, firstName: string, lastName: string) => {
	const response = await fetch(`${API_URL}/singup`, {
	  method: "POST",
	  headers: { "Content-Type": "application/json" },
	  body: JSON.stringify({ email, password, firstName, lastName }),
	});
  
	if (!response.ok) {
	  throw new Error("Erro ao criar conta");
	}
  
	return await response.json();
};
  

// Função para renovar token
export const authRefreshToken = async () => {
  const token = localStorage.getItem("refresh_token");
  if (!token) return null;

  const response = await fetch(`${API_URL}/refresh-token`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ refreshToken: token }),
  });

  if (!response.ok) {
    throw new Error("Erro ao renovar token");
  }

  return await response.json();
};
